<div class="current-position-editor">
  <div class="row">
    <mat-form-field class="mat-form-field-readonly flex-grow" appearance="fill">
      <mat-label>
        <sc-dictionary-label
          dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.current-position-editor.current-position"></sc-dictionary-label>
      </mat-label>
      <input matInput [(ngModel)]="positionName" [readonly]="true">
      <sc-action-icon matSuffix (click)="assignNextProcessingPosition()" iconClass="fa-sitemap"></sc-action-icon>
    </mat-form-field>


  </div>
</div>
